<template>
  <t-form :requiredMark="option.attribute.required" :labelAlign="option.attribute.labelAlign">
    <t-form-item :label="option.attribute.label" class="my_radio" :style="setStyles">
      <t-radio-group v-model="iptVal" :options="options" class="my_radio_item" :style="setStyles" :status="message"
        allowUncheck @change="checkValue" v-if="option.attribute.radioType == 'radio'" />
      <div v-else class="my_radio_button">

        <div v-for="(item, index) in options" :key="index" :style="setStyles"
          :class="['my_radio_button_item', { 'active': iptVal == item.value }]" @click="clickHandler(item.value)">
          {{ item.label }}</div>
        <!-- <p style="color:red;margin-top:10px;">{{iptVal }}</p> -->
        <!-- @change="clickHandler(item)" -->
      </div>
      <!-- <t-radio-group
        v-model="iptVal"
        class="my_radio_item"
        :style="setStyles"
        :status="message"
        allowUncheck
        @change="checkValue"
        v-else>
        <t-radio-button :value="item.value" v-for="(item,i) in options" :key="i">{{item.label}}</t-radio-button>
      </t-radio-group> -->
    </t-form-item>
    <div style="color: #c65c5d; margin-left: 100px; margin-top: -20px">
      {{ tips }}
    </div>
  </t-form>
</template>

<script>
import { ref } from 'vue';
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import { getDefaultValue } from "@/utils/refresh-cpt-data";
export default {
  name: "cpt-radio",
  props: {
    option: Object,
    components: Array,
    current: Object,
    refMap: Object,
  },
  data() {
    return {
      options: [],
      uuid: null,
      iptVal: "",
      newData: "",
      jsFunFlag: false,
      message: "default",
      tips: "",
      // list:[
      //   {id:'1',name:'电子水票'},
      //   {id:'1',name:'大桶装水'},
      //   {id:'1',name:'小瓶装水'},
      //   {id:'1',name:'高端定制'},
      //   {id:'1',name:'饮水设备'}, 
      // ],
      // activeItem:'电子水票'
    };
  },
  watch: {
    // "option.attribute": {
    //   handler(obj) {
    //     this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
    //     const defaultValue = getDefaultValue(obj)
    //     if (defaultValue) {
    //       this.iptVal = defaultValue
    //     }
    //     },
    //   deep: true,
    // },
    "current.cptShow"(val) {
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    const defaultValue = getDefaultValue(this.option.attribute)
    console.log("defaultValue=================================================", defaultValue);
    console.log(typeof (defaultValue));
    console.log(this.options);
    if (defaultValue) {
      this.iptVal = defaultValue
    }
    this.uuid = require("uuid").v1();
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  computed: {
    setStyles() {
      return {
        "--width": this.option.attribute.width + "px",
        "--height": this.option.attribute.height + "px",
        "--top": this.option.attribute.height + "px",
        "--left": this.option.attribute.width + "px",
        "--buttonWidth": this.option.attribute.buttonWidth + "px",
        "--buttonHeight": this.option.attribute.buttonHeight + "px",
        "--buttonTop": this.option.attribute.buttonTop + "px",
        "--buttonButtom": this.option.attribute.buttonButtom + "px",
        "--buttonLeft": this.option.attribute.buttonLeft + "px",
        "--buttonRight": this.option.attribute.buttonRight + "px",

        "--radioSpace": this.option.attribute.radioSpace + "px",

        "--bgColor": this.option.attribute.bgColor,

        "--textColor": this.option.attribute.textColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",

        "--borderSize": this.option.attribute.borderSize + "px",
        "--buttonBorderSize": this.option.attribute.buttonBorderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--buttonBorderRadius": this.option.attribute.buttonBorderRadius + "px",
        "--lineType": this.option.attribute.lineType,

        "--activeTextColor": this.option.attribute.activeTextColor,
        "--activeBgColor": this.option.attribute.activeBgColor,
        "--activeBg": this.option.attribute.activeBg,

        "--activeBorderSize": this.option.attribute.activeBorderSize + "px",
        "--buttonActiveBorderSize": this.option.attribute.buttonActiveBorderSize + "px",
        "--activeBorderColor": this.option.attribute.activeBorderColor,
        "--activeBorderRadius": this.option.attribute.activeBorderRadius + "px",
        "--ButtonActiveBorderRadius": this.option.attribute.ButtonActiveBorderRadius + "px",
        "--activeLineType": this.option.attribute.activeLineType,
        "--layout": this.option.attribute.layout,

        "--marginLeft": this.option.attribute.labelBoolean && this.option.attribute.labelAlign != 'top' ? this.option.attribute.labelWidth + "px" : '0px',
        "--labelWidth": this.option.attribute.labelWidth + "px",
        "--labelBoolean": this.option.attribute.labelBoolean ? 'block' : 'none',
        "--rowScroll": this.option.attribute.rowScroll && this.option.attribute.layout == 'row' ? "auto" : 'visible',
        "--columnScroll": this.option.attribute.columnScroll && this.option.attribute.layout == 'column' ? "auto" : 'visible',
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(
        this.uuid,
        cptDataForm,
        () => {
          this.loadData(cptDataForm, paras);
        },
        this.components
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
        if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return
        console.log(res,'resresresresresresres');
        // 第二层判断 ，如果没有配转换脚本
        // if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            // 创建一个新的数组用于存储结果
            let newres = [];
            // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
            console.log(res, 'aiojsdasoidoiadjiasiojdsa')
            try {
              res.forEach((item) => {
                let newItem = {};
                dataKey.forEach((mapping) => {
                  newItem[mapping.namekey] = item[mapping.value];
                });
                // 合并原有的键值对
                Object.assign(newItem, item);
                newres.push(newItem);
              });
              let newObject
              if(this.option.attribute.defaultValueType == 4){
                 newObject = {
                  value: newres[0].value,
                  options: newres,
                };
              }else{
                 newObject = {
                  value: "",
                  options: newres,
                };
              }
              console.log(newObject,'newObjectnewObjectnewObjectnewObjectnewObject');
              this.funselect(newObject);
            } catch (error) {
              console.log('单选框报错:' ,error)
            }

          }
        // } else {
        //   // 如果配置了转换脚本
        //   this.funselect(res);
        // }
      } else {
        // 不是数据集类型，是静态数据
        this.funselect(this.newData);
      }
    },
    funselect(res) {
      this.options = res.options;
      console.log("======funselect=====", this.option.attribute.defaultValueType)
      if (res.options.length == 1) {
        //只有一个默认是单选
        this.iptVal = res.value || 'true';
      } else {
        this.iptVal = res.value;
      }
      // this.clickHandler(this.iptVal)
      //  this.$emit("clickHandler", this.option.interaction, 'default', this.iptVal, 'cpt-radio');
      if (res.value !== undefined && res.value !== '') {
        setTimeout(() => {
          console.log('fcewewfefw',this.iptVal)
          this.$emit("clickHandler", this.option.interaction, 'default', this.iptVal, 'cpt-radio');

        }, 1300)
      }
    },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      if (attribute.required && (!this.iptVal || this.iptVal.length == 0)) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        // return true;
      }
      this.clickHandler(this.iptVal)

    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必选`;
    },
    clickHandler(item) {
      this.iptVal = item;
      setTimeout(() => {
        this.$emit("clickHandler", this.option.interaction, 'default', this.iptVal, 'cpt-radio');
      }, 300)

      //  if (this.$route.name != "design") {
      //      this.init();
      //  }
    },
    setValue(value) {
      this.iptVal = value
    },
    getValue() {
      return this.iptVal
    },
    // refMap['5cd95200-effb-11ee-8b68-ff153d989a15'].clickHandler(refMap['5cd95200-effb-11ee-8b68-ff153d989a15'].getValue());
    //文本搜索控件组合了单选框，要写一些定制化代码，例如点击回填值到下拉框 
    // init() {
    //   console.log(this.current)
    //     if (Array.isArray(this.current.group) && this.current.group.length > 0) {
    //           const radioComponents = this.components.filter(component => (
    //               this.current.group.includes(component.id) && component.cptKey === 'cpt-radio'
    //            ));
    //               const selectComponents = this.components.filter(component => (
    //               this.current.group.includes(component.id) && component.cptKey === 'cpt-input'
    //            ));
    //            let unequalIds = radioComponents.filter(component => component.id !== this.current.id);
    //            this.refMap[selectComponents[0].id].setValue(this.refMap[this.current.id].getValue())
    //            this.refMap[unequalIds[0].id].setValue('');
    //            console.log(this.refMap[selectComponents[0].id],'this.refMap[selectComponents[0].id]')
    //            this.refMap[selectComponents[0].id].changeInput() //隐藏控件
    //           //  console.log(this.refMap[this.current.id])
    //           //  console.log(this.refMap[unequalIds[0].id])
    //     }
    // }
  },
};

</script>

<style scoped>
.my_radio /deep/ .t-form__label {
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  display: var(--labelBoolean);
  width: var(--labelWidth) !important;
}

:deep(.t-form__controls) {
  margin-left: 0px !important;
}

.my_radio_item /deep/.t-radio__label {
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}

.my_radio_item /deep/ .t-radio {
  margin-right: var(--radioSpace)
}

.my_radio_item /deep/ .t-radio.t-is-checked .t-radio__input {
  background-color: var(--activeBgColor);
  border-width: var(--activeBorderSize);
  border-color: var(--activeBorderColor);
  border-radius: var(--activeBorderRadius);
  border-style: var(--activeLineType);
}

.my_radio_item /deep/ .t-radio__input {
  width: var(--width);
  height: var(--height);
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
}

.my_radio_item /deep/ .t-radio.t-is-checked .t-radio__input::after {
  background-color: var(--activeBg) !important;

}

.my_radio_item /deep/ .t-radio.t-is-checked .t-radio__label {
  color: var(--activeTextColor);
}

.my_radio_item /deep/ .t-radio__input:after {
  content: '✔';
  width: var(--width);
  height: var(--height);
  margin-top: calc(-1 * var(--top) / 2);
  margin-left: calc(-1 * var(--left) / 2);
  transform: none;
  text-align: center;
  font-size: var(--width);
  color: #fff;
}


.my_radio_button {
  display: flex;
  flex-direction: var(--layout);
  /* flex-wrap: wrap; */
}

.my_radio_button_item {
  width: var(--buttonWidth);
  height: var(--buttonHeight);
  background-color: var(--bgColor);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  text-align: center;
  line-height: var(--buttonHeight);
  margin-top: var(--buttonTop);
  margin-bottom: var(--buttonButtom);
  margin-left: var(--buttonLeft);
  margin-right: var(--buttonRight);
  cursor: pointer;
  border-width: var(--buttonBorderSize);
  border-color: var(--borderColor);
  border-radius: var(--buttonBorderRadius);
  border-style: var(--lineType);
}

/* .my_radio_button_item:first-of-type{
   margin-left:0px;
   margin-top:0px;
} */
/* .my_radio_button_item:last-of-type{
  margin-right:0px;
  margin-bottom:0px;
} */
.active {
  color: var(--activeTextColor);
  background-color: var(--activeBgColor);
  border-width: var(--buttonActiveBorderSize);
  border-color: var(--activeBorderColor);
  border-radius: var(--ButtonActiveBorderRadius);
  border-style: var(--activeLineType);
}

.my_radio /deep/ .t-form__controls-content {
  overflow-x: var(--rowScroll);
  overflow-y: var(--columnScroll);
}
</style>
